import React from 'react';
import { Skeleton } from "./styles";

const SeparatorSkeleton = ({
  height,
  color, // Este es el color que viene del hook/props
  absolute = false,
}) => (
  <Skeleton
    $height={height}
    $backgroundColor={color} // Se lo pasamos al estilo que definiste
    style={absolute ? { position: "absolute", inset: 0, zIndex: 1 } : {}}
    aria-hidden="true"
  />
);

export default SeparatorSkeleton;